import type { StaffWorkGroup } from "services/api/company/staff.service";

interface WorkerTeamLabelParts {
  readonly companyUnitName?: string | null;
  readonly teamName?: string | null;
}

export function formatUnitTeamLabel({
  companyUnitName,
  teamName,
}: WorkerTeamLabelParts): string {
  const unitLabel = companyUnitName?.trim() ?? "";
  const teamLabel = teamName?.trim() ?? "";

  if (!unitLabel) return teamLabel;
  if (!teamLabel) return unitLabel;
  return `${unitLabel} - ${teamLabel}`;
}

export function formatWorkerTeamLabels(
  workGroups: readonly StaffWorkGroup[] | undefined,
): readonly string[] {
  return (workGroups ?? [])
    .map((workGroup) =>
      formatUnitTeamLabel({
        companyUnitName: workGroup.companyUnitName,
        teamName: workGroup.workGroupName,
      }),
    )
    .filter((label) => label.length > 0);
}
